import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Page404 = () => {
  // const { authToken, user } = useSelector((state) => state?.Login);
  // useEffect(()=>{
  //   console.log('deepak',authToken);
  //   if(authToken){
  //     alert('logged in')
  //   }
  // },[authToken])

  return (
    <section className="error-page">
      <div className="error-div">
        <h3 className="error-page-not-found">Page No Found!!</h3>
        <div className="back-to-home ">
          <Link to="/" className="back-to-home">
            Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};
export default Page404;
